import styled from 'styled-components';
import colors from 'Styles/colors';

export const Wrapper = styled.div`
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  & > :not(:last-child) {
    margin-right: 7px;
    &::after {
      content: ",";
    }
  }
`;
Wrapper.displayName = 'Wrapper';

export const ItemWrapper = styled.span`
  display: inline-flex;
  align-items: center;
  max-width: 100%;
`;
ItemWrapper.displayName = 'ItemWrapper';

export const Link = styled.a`
    font-size: 13.5px;
    color: ${colors.blueCerulean};
    cursor: pointer;
    text-decoration: none;
`;
Link.displayName = 'Link';

export const EmptyAction = styled.button`
  padding: 0;
  border: 0;
  background: transparent;
  font-size: 13.5px;
  color: ${colors.blueCerulean};
  cursor: pointer;
  text-decoration: none;
`;
EmptyAction.displayName = 'EmptyAction';
